import React from "react";
import useViews from "../..";
import useControllers from "../../../controllers";

export const FullLayout = (props) => {
  const { useComponents } = useViews();
  const { Header, Footer } = useComponents();
  const { useScreensHooks, useLayoutHooks } = useControllers();
  const { useBrand } = useScreensHooks();
  const { useFullLayout } = useLayoutHooks();
  const { children } = props;
  const { colors, brand_image } = useBrand();
  const { showHeader } = useFullLayout();
  return (
    <div>
      {showHeader ? (
        <Header backgroundColor={colors.primary} colorContrast="#7d0b18" imageBrand={brand_image} />
      ) : null}
      {children}
      <Footer />
    </div>
  );
};

export default FullLayout;
